"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _lodash = _interopRequireDefault(require("lodash"));

var _color = _interopRequireDefault(require("color"));

var _objectHash = _interopRequireDefault(require("object-hash"));

var _CheckboxField = _interopRequireDefault(require("./CheckboxField"));

var _styling = require("../../toolkit/styling");

var _providers = require("../../toolkit/providers");

var _device = require("../../toolkit/device");

//
//  src/form/CheckboxGrid.tsx
//  Project-Lego
//
//  Created by Sola Ogunsakin on 11/20/18.
//  Copyright © 2018-present ContextLogic Inc. All rights reserved.
//

/* External Libraries */

/* Lego Components */

/* Lego Toolkit */
var propDoc = {
  options: {
    required: true,
    type: "ReadonlyArray<{ value: any, title: string, icon?: (string | null) }>",
    description: "List of options"
  },
  selected: {
    required: true,
    type: "ReadonlyArray<string>",
    description: "List of values that are currently selected."
  },
  disabled: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "Indicates that selection is disabled"
  },
  onCheckedChanged: {
    required: true,
    type: "(value: any, checked: boolean) => mixed",
    description: "Callback for when a value is selected or deselected"
  },
  hideBorder: {
    required: false,
    type: "boolean",
    defaultValue: "false",
    description: "Hide the border on each option"
  },
  extraContent: {
    required: false,
    type: "string => ReactNode",
    description: "Function input is checkbox value. It returns extra content to be displayed in the checkbox."
  }
};
var demoProps = {
  options: [{
    title: "United States",
    value: "us"
  }, {
    title: "Canada",
    value: "ca"
  }, {
    title: "France",
    value: "fr"
  }, {
    title: "Mexico",
    value: "mx"
  }, {
    title: "Spain",
    value: "es"
  }, {
    title: "Brazil",
    value: "br"
  }, {
    title: "Japan",
    value: "jp"
  }, {
    title: "China",
    value: "cn"
  }],
  onCheckedChanged: function onCheckedChanged() {},
  selected: ["us", "cn"]
};

var CheckboxRow = function CheckboxRow(_ref) {
  var gridProps = _ref.gridProps,
      items = _ref.items,
      parentKey = _ref.parentKey,
      numColumns = _ref.numColumns;
  var styles = useStylesheet(gridProps, numColumns);
  var onCheckedChanged = gridProps.onCheckedChanged,
      disabled = gridProps.disabled,
      selected = gridProps.selected,
      extraContent = gridProps.extraContent;
  return /*#__PURE__*/_react["default"].createElement("tr", {
    key: "".concat(parentKey, "_row")
  }, items.map(function (option) {
    var value = option.value,
        icon = option.icon,
        title = option.title;
    var checked = selected.includes(value);
    return /*#__PURE__*/_react["default"].createElement("td", {
      key: title,
      className: (0, _styling.css)(styles.column)
    }, /*#__PURE__*/_react["default"].createElement(_CheckboxField["default"], {
      className: (0, _styling.css)(styles.item, checked ? styles.selectedItem : styles.unselectedItem),
      checked: checked,
      disabled: disabled,
      onChange: function onChange(checked) {
        onCheckedChanged(value, checked);
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _styling.css)(styles.checkboxContent)
    }, icon && /*#__PURE__*/_react["default"].createElement("img", {
      src: icon,
      alt: "wish express",
      className: (0, _styling.css)(styles.checkboxIcon)
    }), /*#__PURE__*/_react["default"].createElement("section", {
      className: (0, _styling.css)(styles.checkboxTitle)
    }, title), extraContent && extraContent(value))));
  }));
};

var CheckboxGrid = function CheckboxGrid(props) {
  var className = props.className,
      style = props.style,
      _props$maxColumns = props.maxColumns,
      maxColumns = _props$maxColumns === void 0 ? 2 : _props$maxColumns,
      options = props.options;

  var _DeviceStore$instance = _device.DeviceStore.instance(),
      isSmallScreen = _DeviceStore$instance.isSmallScreen,
      isVeryLargeScreen = _DeviceStore$instance.isVeryLargeScreen;

  var numColumns = 2;

  if (isSmallScreen) {
    numColumns = 1;
  } else if (isVeryLargeScreen) {
    numColumns = maxColumns;
  }

  var styles = useStylesheet(props, numColumns);

  var rows = _lodash["default"].chunk((0, _toConsumableArray2["default"])(options), numColumns);

  var rootCSS = (0, _styling.css)(styles.root, style, className);
  return /*#__PURE__*/_react["default"].createElement("table", {
    className: rootCSS
  }, /*#__PURE__*/_react["default"].createElement("tbody", null, rows.map(function (row) {
    var key = row.map(function (_) {
      return (0, _objectHash["default"])(_);
    }).join(",");
    return /*#__PURE__*/_react["default"].createElement(CheckboxRow, {
      gridProps: props,
      numColumns: numColumns,
      items: row,
      key: key,
      parentKey: key
    });
  })));
};

CheckboxGrid.propDoc = propDoc;
CheckboxGrid.demoProps = demoProps;

var _default = (0, _mobxReact.observer)(CheckboxGrid);

exports["default"] = _default;

var useStylesheet = function useStylesheet(props) {
  var numColumns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var disabled = props.disabled,
      hideBorder = props.hideBorder;

  var _useTheme = (0, _providers.useTheme)(),
      primary = _useTheme.primary,
      surfaceLightest = _useTheme.surfaceLightest,
      textBlack = _useTheme.textBlack;

  var selectedBorderColor = new _color["default"](primary).lighten(0.1);
  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      root: {
        display: "table",
        tableLayout: "fixed"
      },
      column: {
        width: "".concat(Math.round(1 / numColumns * 100), "%")
      },
      item: {
        flex: 1,
        borderRadius: 4,
        padding: "10px 15px 10px 15px",
        margin: "10px 10px",
        transition: "all 0.2s linear",
        opacity: !disabled ? 0.9 : 1,
        ":hover": {
          opacity: !disabled ? 1 : undefined
        },
        backgroundColor: surfaceLightest
      },
      unselectedItem: {
        border: !hideBorder ? "1px solid rgba(175, 199, 209, 0.5)" : undefined
      },
      selectedItem: {
        border: !hideBorder ? "1px solid ".concat(selectedBorderColor) : undefined
      },
      checkboxContent: {
        display: "flex",
        alignItems: "center",
        flexDirection: "row"
      },
      checkboxTitle: {
        fontSize: 14,
        color: textBlack,
        margin: 0,
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        textRendering: "optimizeSpeed"
      },
      checkboxIcon: {
        height: 14,
        borderRadius: 2,
        marginRight: 6
      }
    });
  }, [disabled, hideBorder, surfaceLightest, textBlack, selectedBorderColor, numColumns]);
};